import Nightcars from "../images/Nightcars.png"; 
import Carblue from "../images/Carblue.png";
import Motorcycle from "../images/Motorcycle.png";
import Fleet from "../images/Fleet.png";

function Homepage() {
  return (
    <div className="mt-12">

      {/* Grid Level -1 */}
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 p-12 space-y-20 mt-18">

        {/* Left Side - Text */}
        <div className="flex flex-col justify-center items-start space-y-4 md:px-8">
          <h1 className="text-5xl font-bold">Secure Your Vehicle</h1>
          <p className="text-lg text-gray-600">
            Real-time GPS tracking, instant alerts, and premium installation by Ledot Prime.
          </p>
          <p className="text-gray-500">
            Protect your car or bike with smart monitoring, receive instant notifications, and ensure peace of mind wherever you are.
          </p>
        </div>

        {/* Right Side - Image */}
        <div className="flex justify-center items-center transition-transform transform hover:scale-110 duration-300">
          <img
            src={Nightcars}
            alt="GPS Tracking Overview"
            className="w-full rounded-lg max-h-[400px] object-cover"
          />
        </div>
      </div>

      {/* Grid Level -2 */}
      <div className="grid md:grid-cols-2 grid-cols-1 gap-6 p-8">

        {/* Image */}
        <div className="flex justify-center items-start transition-transform transform hover:scale-110 duration-300">
          <img src={Carblue} alt="Car GPS Tracking" className="w-full rounded-lg max-h-[400px] object-cover" />
        </div>

        {/* Text */}
        <div className="flex flex-col justify-center items-start space-y-4 md:px-8">
          <h1 className="text-5xl font-bold">GPS Car Tracking</h1>
          <p className="text-lg text-gray-600">
            Track your vehicle anytime, anywhere with instant alerts and live location updates.
          </p>
          <ul className="list-disc list-inside text-gray-500 space-y-1">
            <li>Real-time location monitoring</li>
            <li>Speed and route history</li>
            <li>Immediate theft alerts</li>
          </ul>
        </div>
      </div>

      {/* Grid Level -3 */}
      <div className="grid md:grid-cols-2 grid-cols-1 gap-6 p-8">

        {/* Left - Text */}
        <div className="flex flex-col justify-center items-start space-y-4 md:px-8">
          <h1 className="text-5xl font-bold">Motorbike Tracking</h1>
          <p className="text-lg text-gray-600">
            Protect your bike with real-time GPS monitoring and anti-theft features.
          </p>
          <ul className="list-disc list-inside text-gray-500 space-y-1">
            <li>Instant location updates</li>
            <li>Speed alerts and geo-fencing</li>
            <li>Emergency notifications</li>
          </ul>
        </div>

        {/* Right - Image */}
        <div className="flex justify-center items-center transition-transform transform hover:scale-110 duration-300">
          <img
            src={Motorcycle}
            alt="Motorbike Tracking"
            className="w-full rounded-lg max-h-[400px] object-cover"
          />
        </div>
      </div>

      {/* Grid Level -4 */}
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 p-12 space-y-20">

        {/* Image */}
        <div className="flex justify-start items-start transition-transform transform hover:scale-110 duration-300">
          <img src={Fleet} alt="Fleet Management" className="w-full rounded-lg object-cover" />
        </div>

        {/* Text */}
        <div className="flex flex-col justify-center items-start space-y-4 md:px-8">
          <h1 className="text-5xl font-bold">Fleet Management</h1>
          <p className="text-lg text-gray-600">
            Monitor all your vehicles, control movement, analyze routes, and reduce fuel loss.
          </p>
          <ul className="list-disc list-inside text-gray-500 space-y-1">
            <li>Real-time fleet tracking</li>
            <li>Route optimization and analytics</li>
            <li>Fuel and maintenance management</li>
          </ul>
        </div>
      </div>

    </div>
  );
}

export default Homepage;
